<!-- 
  
<mat-sidenav-container class="container">

    <app-side-nav> </app-side-nav> 

    <main>

      <router-outlet></router-outlet>

      <app-footer> </app-footer>

    </main>

</mat-sidenav-container> 

-->


<router-outlet></router-outlet>



